module.exports = __webpack_public_path__ + "img/72.80dd3ffd.jpg";